module.exports = __webpack_public_path__ + "static/media/1.a25455c8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/images/80196/1.jpg
// module id = 759
// module chunks = 0